var map = {
	"./R104 Белая Тайга_ZOOM.webp": 6834,
	"./R112 Соль Каспия_ZOOM.webp": 8710,
	"./R122 Алмазы Якутии_ZOOM.webp": 8169,
	"./R403 Скалы Карелии_ZOOM.webp": 1431,
	"./R444 Ай-Петри_ZOOM.webp": 5801,
	"./R500 Жемчуг приморья_ZOOM.webp": 4492,
	"./R503 Уральские Горы_ZOOM.webp": 4961,
	"./R510 Черное Море_ZOOM.webp": 7728,
	"./R511 Лед Байкала_ZOOM.webp": 4295,
	"./R515 Вулканы Камчатки_ZOOM.webp": 7207,
	"./R520 Астраханские пески_ZOOM.webp": 9260,
	"./R522 Золотое кольц_ZOOM.webp": 3546,
	"./R531 Донская степь_ZOOM.webp": 4100,
	"./R538 Горы Кавказа_ZOOM.webp": 9130,
	"./R541 Снега Сибири_ZOOM.webp": 3863,
	"./R543 Пик Эльбруса_ZOOM.webp": 8949,
	"./R555 Балтийский берег_ZOOM.webp": 7383,
	"./R558 Просторы Поволжья_ZOOM.webp": 5053,
	"./R560-Золотые-ворота_ZOOM.webp": 4666,
	"./R575-Красная-Поляна_ZOOM.webp": 4493,
	"./R590-Северное-сияние_ZOOM.webp": 5832,
	"./R677 Московская Ночь_ZOOM.webp": 1060,
	"./RM560-Золотые-ворота_ZOOM.webp": 3529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3254;